import React from 'react';
import { FiArrowDown, FiArrowRight } from 'react-icons/fi';

const VisualDiagram = ({ type, data, title }) => {
  const renderClassDiagram = () => (
    <div className="diagram-container">
      <div className="diagram-header">{title}</div>
      <div className="class-diagram">
        {/* Base Class */}
        <div className="diagram-box base-class">
          <div className="box-title">🏏 {data.baseClass.name}</div>
          <div className="box-divider"></div>
          <div className="box-section">
            <div className="box-label">Properties:</div>
            {data.baseClass.properties.map((prop, idx) => (
              <div key={idx} className="box-item">• {prop}</div>
            ))}
          </div>
          <div className="box-divider"></div>
          <div className="box-section">
            <div className="box-label">Methods:</div>
            {data.baseClass.methods.map((method, idx) => (
              <div key={idx} className="box-item">• {method}</div>
            ))}
          </div>
        </div>

        {/* Inheritance Arrow */}
        <div className="inheritance-arrows">
          <FiArrowDown size={32} className="arrow-icon" />
          <div className="arrow-label">inherits from</div>
        </div>

        {/* Child Classes */}
        <div className="child-classes">
          {data.childClasses.map((child, idx) => (
            <div key={idx} className="diagram-box child-class">
              <div className="box-title">{child.icon} {child.name}</div>
              <div className="box-divider"></div>
              <div className="box-section">
                <div className="box-label">Adds:</div>
                {child.additions.map((add, i) => (
                  <div key={i} className="box-item">+ {add}</div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  const renderFlowDiagram = () => (
    <div className="diagram-container">
      <div className="diagram-header">{title}</div>
      <div className="flow-diagram">
        {data.steps.map((step, idx) => (
          <React.Fragment key={idx}>
            <div className="flow-step">
              <div className="flow-number">{idx + 1}</div>
              <div className="flow-content">
                <div className="flow-title">{step.emoji} {step.title}</div>
                <div className="flow-description">{step.description}</div>
              </div>
            </div>
            {idx < data.steps.length - 1 && (
              <FiArrowDown size={24} className="flow-arrow" />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );

  const renderComparisonDiagram = () => (
    <div className="diagram-container">
      <div className="diagram-header">{title}</div>
      <div className="comparison-diagram">
        {data.items.map((item, idx) => (
          <div key={idx} className="comparison-card">
            <div className="comparison-icon">{item.icon}</div>
            <div className="comparison-title">{item.title}</div>
            <div className="comparison-divider"></div>
            {item.points.map((point, i) => (
              <div key={i} className="comparison-point">
                {point.emoji} {point.text}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );

  switch (type) {
    case 'class':
      return renderClassDiagram();
    case 'flow':
      return renderFlowDiagram();
    case 'comparison':
      return renderComparisonDiagram();
    default:
      return null;
  }
};

export default VisualDiagram;

